import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeSore2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 211,
	height: 203,
	viewBox: "0 0 211 203",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M180.499 47.596C181.043 42.5996 177.955 44.1784 174.265 44.1727C171.913 45.1751 174.583 50.8303 174.451 53.0872C174.768 54.2603 175.517 55.7276 176.903 55.8787C181.02 56.2432 179.679 50.2158 180.499 47.596ZM131.876 54.0921C131.372 51.0666 132.766 46.4856 128.091 48.2144C126.524 48.8957 121.978 47.2243 122.511 49.9677C123.045 58.8592 130.885 69.8995 131.876 54.0921ZM162.128 44.7735C160.792 45.4153 156.713 43.9496 156.768 46.285C157.542 49.5125 158.321 52.7389 159.124 55.9586C159.877 61.6254 167.852 59.013 167.486 54.1798C166.809 49.4276 169.259 43.4694 162.128 44.7735ZM192.799 43.804C190.067 43.7864 186.381 42.9444 187.823 46.882C188.655 50.5416 188.381 56.1213 192.639 57.5721C194.335 57.8715 197.509 59.5523 197.899 56.846C198.53 53.7801 198.585 50.6749 198.24 47.5831C198.077 42.7949 197.635 43.5161 192.799 43.804ZM151.067 52.1779C150.714 42.329 147.614 46.8161 139.765 46.5106C137.451 47.1562 140.429 52.5446 140.516 54.4133C142.767 64.7171 151.702 62.183 151.067 52.1779ZM187.274 37.7307C187.273 37.6702 187.272 37.6095 187.272 37.5494C205.136 37.4167 200.564 37.118 195.972 22.3544C192.785 13.7209 171.744 5.06873 162.85 5.85993C150.188 9.50717 137.605 16.961 129.159 27.139C125.926 31.9615 122.413 36.6233 119.771 41.8065C117.642 45.5087 129.936 43.1367 131.778 42.751C150.104 39.9688 168.78 38.7636 187.274 37.7307ZM154.52 59.7515C151.967 63.6234 148.21 65.8849 143.606 65.3111C138.663 65.8501 137.126 55.1729 135.149 61.5863C126.265 75.2217 117.408 60.9017 117.976 50.2147C117.921 49.6314 117.616 49.1957 116.991 49.2696C112.324 48.3614 113.287 40.768 114.993 37.5046C124.368 21.3728 117.118 32.9131 104.201 23.6329C99.1615 20.6088 91.8232 4.76296 103.558 9.0992C104.929 16.8915 113.277 21.6228 119.635 25.9115C121.722 27.4425 122.762 23.7706 123.952 22.5876C125.899 19.6681 128.484 17.2731 131.096 14.9786C131.155 14.1162 130.488 14.0995 130.093 13.8626C124.433 10.5217 120.907 3.13082 123.917 -2.87602C126.195 -5.00486 126.805 -2.2458 126.856 -0.440592C127.56 4.12038 131.905 11.8901 137.033 10.9857C142.94 7.3058 148.938 3.71461 155.534 1.39402C158.854 0.224241 153.601 -8.93918 153.838 -12.1936C152.891 -15.8218 156.937 -17.5125 158.941 -14.2905C161.485 -10.7312 163.301 -6.72133 164.226 -2.45899C164.837 -0.199658 164.841 -0.217515 167.169 -0.316141C174.402 -0.0298786 181.531 2.28522 187.854 5.83933C194.493 9.50222 195.843 -14.2504 201.296 -9.51445C206.799 2.15143 194.407 8.02558 196.557 10.6866C200.551 13.2852 202.093 17.4357 203.724 21.6931C208.169 20.2511 212.607 19.8239 216.496 17.3352C217.844 16.4324 220.297 14.7596 220.991 17.2137C224.111 22.6958 217.393 24.4634 213.121 25.3755C200.218 26.8134 205.871 24.6464 207.598 39.2705C208.717 43.0699 204.575 41.4438 203.956 43.9273C203.684 48.8666 203.983 53.9564 202.698 58.763C200.439 67.0028 189.155 64.4874 184.928 59.0965C184.249 58.2446 183.852 58.2147 183.203 59.1009C180.635 62.2369 175.577 62.6844 172.472 60.4385C168.274 56.4833 163.885 72.0212 154.52 59.7515Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.8179 50.1046C19.2551 55.0011 16.7477 59.0487 23.7813 55.5817C32.2811 50.8677 37.631 58.2688 30.6365 64.82C29.6695 65.7155 27.7429 64.6519 28.2087 63.3932C33.0008 51.7894 21.2474 63.2138 16.2274 60.4142C8.6693 54.7947 24.802 41.7067 2.91625 51.1881C-9.319 51.9553 20.9764 34.4405 19.8179 50.1046Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M35.4722 8.83056C31.2618 17.5246 23.1637 27.9257 14.4559 32.3057C6.42444 30.5933 16.5656 22.9922 18.7844 19.9907C21.4857 18.0414 34.4458 0.342135 35.4722 8.83056Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M96.3571 33.6417C99.9711 34.5052 93.8494 38.27 92.9474 39.6175C84.0677 47.3492 75.8206 55.6898 67.4138 63.7169C55.2813 65.2717 92.485 31.5062 96.3571 33.6417Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M217.799 88.2958C215.643 94.7729 200.907 93.2383 195.556 91.4467C192.167 90.87 180.195 81.398 187.233 79.6245C198.123 87.0637 204.973 87.3782 217.799 88.2958Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M220.693 129.461C220.677 134.599 207.499 137.427 203.459 140.261C200.622 140.741 178.66 154.489 180.168 148.894C189.633 140.591 202.435 136.843 213.433 130.856C215.406 130.286 221.559 124.436 220.693 129.461Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M201.384 108.36C197.475 108.482 178.126 104.043 183.515 98.2051C189.48 100.191 195.601 103.965 202.465 103.02C207.52 103.398 212.601 100.371 217.486 101.435C222.209 107.132 204.864 107.95 201.384 108.36Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M171.441 136.853C170.789 136.561 170.431 136.478 170.842 135.955C178.868 130.669 187.771 127.05 196.731 123.698C201.234 123.32 218.508 109.429 219.535 116.134C219.1 119.365 214.192 118.809 211.923 120.411C199.112 127.314 184.95 131.576 171.441 136.853Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M31.071 33.1199C31.2255 28.2887 46.9689 8.68292 51.6726 11.8365C52.41 13.3928 50.5869 14.9351 49.8839 16.2161C46.2248 20.7479 42.8332 25.4641 39.82 30.4561C38.4341 32.422 36.1882 36.3717 33.3326 34.9921C32.4806 34.4218 30.6451 34.5963 31.071 33.1199Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M133.046 81.1363C150.011 80.3564 156.768 97.8105 146.393 91.7037C137.435 79.9193 124.95 88.5411 117.333 84.8034C119.988 81.0633 127.772 81.6895 133.046 81.1363Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M176.17 125.952C173.901 124.692 175.513 120.105 172.921 119.457C171.026 119.561 163.267 120.099 167.393 116.725C172.045 115.441 174.06 115.981 172.95 110.31C172.3 107.956 174.645 105.211 176.216 108.154C176.84 109.888 176.994 111.81 177.518 113.555C179.574 115.874 183.412 113.097 186.046 114.169C185.811 118.091 178.761 117.107 178.281 119.949C178.351 122.108 179.118 125.445 176.17 125.952Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M194.705 161.379C191.276 158.306 201.092 155.942 203.018 154.585C209.007 151.998 215.021 149.467 221.025 146.915C221.629 146.613 223.021 146.143 223.207 147.014C224.095 148.889 224.783 150.146 222.125 151.064C213.157 154.951 204.047 158.474 194.705 161.379Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M82.1084 28.6043C80.7723 33.4951 70.4865 22.2574 68.4347 20.577C66.6033 19.0753 65.8743 17.2555 68.1464 15.7418C72.1125 11.6471 81.7062 24.8586 82.1084 28.6043Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M86.4749 61.5392C78.7289 61.0779 100.874 42.7803 102.946 46.7398C98.9145 52.3774 93.3134 59.6756 86.4749 61.5392Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M214.581 79.8719C209.32 78.6098 191.697 76.8533 192.524 69.2812C193.376 68.3602 194.688 69.7468 195.537 70.1402C199.959 73.0336 204.861 74.5544 210.031 75.3616C211.857 76.0436 217.499 75.8953 218.046 77.5203C217.907 80.019 216.655 79.6657 214.581 79.8719Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M139.907 96.4099C139.672 98.6659 138.351 100.328 136.431 98.2388C132.656 94.3642 127.058 95.5525 122.225 94.7605C116.485 89.08 139.401 89.327 139.907 96.4099Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M66.1712 39.9099C62.6087 39.2298 50.8324 31.5652 56.2024 27.5986C61.0025 28.6508 64.4516 34.4238 68.6047 37.251C70.7434 38.8887 68.4532 40.3376 66.1712 39.9099Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M48.2962 59.035C45.7185 59.5654 33.837 48.5644 35.3587 46.4946C41.6633 45.5619 44.8103 54.5253 50.371 56.5263C51.8416 57.6365 49.5944 59.2917 48.2962 59.035Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M172.276 79.7667C171.878 79.6006 171.634 79.4986 171.39 79.3965C170.822 80.3684 171.676 80.7963 172.276 79.7667ZM172.546 75.6981C180.264 75.0683 175.643 86.4196 169.989 84.3199C164.157 82.9149 167.655 75.0538 172.546 75.6981Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M211.597 196.016C210.607 200.609 198.519 188.593 197.07 186.624C194.963 184.018 197.162 182.42 199.299 184.948C202.76 189.184 208.799 191.496 211.597 196.016Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M49.4946 38.9946C53.3037 41.5448 57.0795 45.6162 58.7907 49.8448C54.8431 50.615 42.4769 42.3717 49.4946 38.9946Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.87482 16.2021C-0.458387 14.3679 8.76069 7.941 10.566 6.35339C12.1461 4.91756 15.776 6.4701 14.2824 8.62098C11.1612 11.339 8.07123 15.4119 3.87482 16.2021Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M209.246 172.514C206.625 172.731 205.89 170.301 208.562 169.562C213.585 168.428 219.046 164.596 224 165.15C221.965 169.717 213.833 171.179 209.246 172.514Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M133.886 107.7C133.767 108.917 132.844 109.721 131.874 108.496C130.267 106.768 127.924 106.365 126.007 105.134C124.036 100.041 134.904 103.795 133.886 107.7Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M216.203 187.277C214.714 187.663 210.359 186.563 212.362 184.673C214.848 183.705 218.173 183.607 220.6 184.782C222.459 187.162 217.679 187.283 216.209 187.392C216.207 187.354 216.205 187.316 216.203 187.277Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M106.418 65.5087C104.51 68.076 101.416 65.0985 102.033 62.5818C104.125 58.8357 106.325 62.7683 106.418 65.5087Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M195.582 194.577C203.089 197.037 202.349 202.377 195.509 196.9C194.89 196.095 194.687 195.365 195.582 194.577Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M192.629 202.624C191.578 203.714 189.518 202.188 188.819 201.162C189.283 198.175 192.072 201.25 192.629 202.624Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M163.192 32.6612C174.251 32.9576 173.288 24.4314 167.956 17.6599C164.16 14.6944 158.662 16.104 154.814 18.3318C151.852 19.9505 151.286 23.1071 152.082 26.2082C153.215 31.577 158.282 32.6783 163.192 32.6612ZM161.976 37.1479C136.476 37.9049 141.045 6.57551 165.351 10.9176C181.044 15.845 180.735 39.0691 161.976 37.1479Z",
			fill: "#79C912",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M160.818 28.0304C152.481 27.219 158.759 15.8537 164.258 20.5608C169.184 23.2036 165.94 28.7472 160.818 28.0304Z",
			fill: "#79C912",
			fillOpacity: .1
		})
	]
});
export default SvgEyeSore2;
